import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  globalFeatureFlagPollingService,
  initializeStatsig,
} from "@nextiva/ncx-feature-management";
import Cookies from "js-cookie";
import closeImg from "../images/close-icon.png";
import IframeContainer from "../utils/IframeContainer/IframeContainer";

import PopUpMessage from "./CommonUtils/PopUpMessage";
import ConversationPage from "./Conversation/ConversationPage";
import MessageNotification from "./Conversation/MessageNotification";
import HWLog from "./HWLibrary/HWLog";
import HWUser from "./HWLibrary/HWUser";
import InitialForm from "./InitialForm/InitialForm";
import LandingPage from "./LandingPage/LandingPage";
import apiService from "./Services/APIService";

import {
  requestNotification,
  sendOnAppClose,
  sendOnAppOpen,
} from "./Services/HWIframeBridge";
import { s360ConfigService } from "./Services/S360Config";
import StartUp from "./StartUp";

import "react-block-ui/style.css";
import "../assets/styles/style.css";
import {
  initChatWSConnection,
  safeReconnectWebSocket,
  disconnectWorkitem,
} from "../websocket/ws";
import DynamicForm from "./CommonUtils/DynamicForm";
import OfflineMessage from "./OfflineMessage/OfflineMessage";

import InitialFormHeader from "./InitialForm/InitialFormHeader";
import InitialChannelFormDetails from "./InitialForm/InitialChannelFormDetails";
import { LoaderProviderWrapper } from "./Conversation/utils/loaderContext";
import { set } from "lodash";
import {
  getCookieForContactDetails,
  setCookieForContactDetails,
  setCookieForPrimaryIdentification,
} from "./Conversation/utils/ConversationUtils";
import { CListGroup } from "@coreui/react";
import TermsAndCondition from "./Conversation/TermsAndConditions/TermsAndCondition";
import LandingPageHeader from "./LandingPage/LandingPageHeader";
import TermsAndConditionHeader from "./LandingPage/TermsAndContiotionHeader";
import NCXPrivacyPolicyBig from "./Conversation/MessageBoxTypes/NCXComponents/NCXPrivacyPolicyBig";
import { usePrimaryIdentification } from "../context/PrimaryIdentificationContext";
export const PageName = {
  initialForm: "initialForm",
  landingPage: "landingPage",
  conversationPage: "conversationPage",
  offlinePage: "offlinePage",
  privacyPage: "privacyPage",
};

// Message status constants (matching ConversationPage)
const messageStatuses = {
  DELIVERED: "DELIVERED",
  READ: "READ",
};

// Track message IDs that need status updates when app becomes active
let messageStatusPendingMap = new Map();

function Simplify360Chat(props) {
  const chatMaximizedTrigger = useRef(false);
  const [visiblePage, setVisiblePage] = useState(PageName.initialForm);
  const [isAppOpen, setIsAppOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState(null);
  const [showActivityIndicator, setShowActivityIndicator] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [timer, setTimer] = useState(0);
  const [text, setText] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [refreshForFullScreen, setRefreshForFullScreen] = useState(false);
  const [showFeedbackIframe, setShowFeedbackIframe] = useState(false);
  const [iframeSRC, setIframeSRC] = useState("");
  const [isIframeClose, setIsIframeClose] = useState(false);
  const [uniboxSingleRefresh, setUniboxSingleRefresh] = useState(false);
  const [messageCounter, setMessageCounter] = useState(10);
  const [sessionIdForClose, setSessionIdForClose] = useState(null);
  const [activeConversation, setActiveConversation] = useState(null);
  const [clientChannel, setClientChannel] = useState(null);
  const [autoLoggedIn, setAutoLoggedIn] = useState(false);
  const [sandBoxedReadreciept, setSandBoxedReadreciept] = useState(false);
  const [hasMinimizedOnce, setHasMinimizedOnce] = useState(false);
  const [pendoAutoOpened, setPendoAutoOpened] = useState(false);
  const [sandBoxedAgentInfo, setSandBoxedAgentInfo] = useState(false);
  const [sandBoxedAttachment, setSandBoxedAttachment] = useState(false);

  const [errorMessage, setErrorMessage] = useState(null);
  const isFullScreen = localStorage.getItem("openInFullScreen");
  const [agentInfo, setAgentInfo] = useState(null);
  const [dynamicFormData, setDynamicFormData] = useState(null);
  const [downloadHistoryForWorkItemId, setDownloadHistoryForWorkItemId] =
    useState(false);
  const [showChannels, setShowChannels] = useState(false);
  const [moveNextFromChannels, setMoveNextFromChannels] = useState(false);

  const widgetId = s360ConfigService.config.widgetconfigId;
  const [backupMessages, setBackupMessages] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(() =>
    getCookieForContactDetails(widgetId),
  );
  const [termsAccepted, setTermsAccepted] = useState(
    !s360ConfigService.config.preview &&
      localStorage.getItem(
        `nextiva-widget-terms-acceptance-${s360ConfigService?.config?.widgetconfigId}`,
      ) === "true",
  );
  let intervalId = 0;
  const sandBox = s360ConfigService.config?.sandBox;
  const { primaryIdentification, updatePrimaryIdentification } =
    usePrimaryIdentification();

  // NEW: Helper to standardize offline checks
  const isOffline = s360ConfigService?.config?.isCurrentWorkingHour === false;

  // Determining initial page
  const closeAndPostMessage = () => {
    setIsAppOpen(false);
    sendOnAppClose();
  };

  const determineInitialPage = () => {
    const privacyPolicyEnabled =
      s360ConfigService.config?.configDetails?.privacyPolicyDetails;
    const widgetKey = `nextiva-widget-terms-acceptance-${s360ConfigService?.config?.widgetconfigId}`;
    const hasAccepted = localStorage.getItem(widgetKey) === "true";
    if (s360ConfigService.config.preview) {
      return PageName.conversationPage;
    }
    if (s360ConfigService.config.sandBox) {
      if (!s360ConfigService.config.autoPopup) {
        closeAndPostMessage();
      } else {
        sendOnAppOpen();
      }

      if (s360ConfigService.config.showChannels) {
        return PageName.initialForm;
      }

      // Sandbox offline: show offline page when not in working hours
      if (s360ConfigService.config.isCurrentWorkingHour === false) {
        if (
          s360ConfigService.config.businessHour?.offlineHour?.formEnabled &&
          s360ConfigService.config.layoutElements?.layout?.elements
        ) {
          setDynamicFormData(
            s360ConfigService.config.layoutElements?.layout?.elements,
          );
        }
        return PageName.offlinePage;
      }

      if (s360ConfigService.config.layoutElements?.layout?.elements) {
        setDynamicFormData(
          s360ConfigService.config.layoutElements?.layout?.elements,
        );
        return PageName.initialForm;
      } else {
        return PageName.conversationPage;
      }
    } else {
      //non sandbox code
      if (s360ConfigService?.config?.showChannels) {
        return PageName.initialForm;
      }
      if (!s360ConfigService?.config?.isCurrentWorkingHour) {
        return PageName.offlinePage;
      } else if (
        s360ConfigService?.config?.anonymous ||
        (s360ConfigService?.config?.connectTonextiva &&
          !s360ConfigService?.config?.showChannels)
      ) {
        if (privacyPolicyEnabled && !hasAccepted) {
          return PageName.privacyPage;
        }
        return PageName.conversationPage;
      } else if (s360ConfigService?.config?.preview) {
        return PageName.conversationPage;
      }
      if (
        s360ConfigService?.config?.configDetails?.privacyPolicyDetails?.enabled
      ) {
        if (
          s360ConfigService?.config?.configDetails?.privacyPolicyDetails
            ?.type === "full"
        ) {
          return PageName.privacyPage;
        } else {
          return PageName.initialForm;
        }
      }
      return PageName.initialForm;
    }
  };
  const dynamicFormKey = useMemo(() => {
    const le = s360ConfigService?.config?.layoutElements;
    // Prefer a stable server-side field if you have one:
    return (
      le?.modifiedAt ||
      le?._id ||
      JSON.stringify(le?.layout?.elements || []).length // fallback if nothing else
    );
  }, [s360ConfigService?.config?.layoutElements]);

  useEffect(() => {
    if (s360ConfigService.config.configDetails?.browserNotification) {
      requestNotification();
    }

    if (s360ConfigService.config.sandBox) {
      setSandBoxedReadreciept(
        s360ConfigService.config.configDetails?.showReadReceipt,
      );
      setSandBoxedAgentInfo(
        s360ConfigService.config.configDetails?.showAgentInfo,
      );

      setSandBoxedAttachment(!s360ConfigService.config?.hideAttachment);
      document.documentElement.style.setProperty(
        "--primary-color",
        s360ConfigService?.config?.configDetails?.primaryColor,
      );
      document.documentElement.style.setProperty(
        "--widget-width",
        s360ConfigService?.config?.configDetails?.customDesign
          .startupFloatContainerLaunchIcon.width || "45px",
      );
    }
  }, [s360ConfigService.config]);
  useEffect(() => {
    const launchIconHeight =
      document.getElementById("test-container")?.clientHeight / 10;

    document.documentElement.style.setProperty(
      "--launchIcon-height",
      `${launchIconHeight + 2}rem`,
    );

    setShowChannels(s360ConfigService?.config?.showChannels);
    setTimeout(() => {
      console.log(
        s360ConfigService?.config?.isCurrentWorkingHour,
        "workinghrs",
      );
      if (
        !showChannels &&
        !s360ConfigService?.config?.preview &&
        !s360ConfigService?.config?.anonymous &&
        !s360ConfigService?.config?.connectToNextiva
      ) {
        if (
          s360ConfigService?.config?.isCurrentWorkingHour !== false &&
          !s360ConfigService.config.sandBox
        ) {
          apiService
            .getSurveyData(
              s360ConfigService?.getConfig().preSurveyId ??
                "6748880b02f33a0822814c69",
            )
            .then((res) => {
              setDynamicFormData(res.data?.layout?.elements);
            })
            .catch((err) => {});
        } else {
          // Offline: only fetch when offline form is enabled
          const offlineEnabled =
            s360ConfigService?.config?.businessHour?.offlineHour?.formEnabled;
          const offlineSurveyId =
            offlineEnabled &&
            s360ConfigService?.config?.businessHour?.offlineHour?.surveyId;
          if (offlineSurveyId && !s360ConfigService.config.sandBox) {
            apiService
              .getSurveyData(offlineSurveyId)
              .then((res) => {
                setDynamicFormData(res.data?.layout?.elements);
              })
              .catch((err) => {});
          } else {
            setDynamicFormData(null);
          }
        }
      } else if (
        s360ConfigService.config.isCurrentWorkingHour === false &&
        s360ConfigService.config.anonymous
      ) {
        const offlineEnabled =
          s360ConfigService?.config?.businessHour?.offlineHour?.formEnabled;
        const offlineSurveyId =
          offlineEnabled &&
          s360ConfigService.config.businessHour?.offlineHour?.surveyId;
        if (offlineSurveyId && !s360ConfigService.config.sandBox) {
          apiService
            .getSurveyData(offlineSurveyId)
            .then((res) => {
              setDynamicFormData(res.data?.layout?.elements);
            })
            .catch((err) => {});
        } else {
          setDynamicFormData(null);
        }
      }
    }, 0);
  }, []);
  const decideTermsAndConditionRendering = useMemo(() => {
    const privacyPolicy =
      s360ConfigService.config?.configDetails?.privacyPolicyDetails;
    const widgetKey = `nextiva-widget-terms-acceptance-${s360ConfigService?.config?.widgetconfigId}`;
    const hasAccepted = localStorage.getItem(widgetKey) === "true";
    const sandBox = s360ConfigService.config?.sandBox;
    const privacyScreen = s360ConfigService?.config?.privacy;

    // default fallback
    let result = { showTerms: false, targetPage: PageName.conversationPage };
    if (sandBox && !privacyScreen) {
      result = {
        showTerms: false,
        targetPage: determineInitialPage(),
      };
    }
    if (privacyScreen && sandBox && privacyPolicy?.enabled) {
      if (privacyPolicy.type === "full") {
        result = { showTerms: true, targetPage: PageName.privacyPage };
      } else if (privacyPolicy?.type === "compact") {
        result = {
          showTerms: false,
          targetPage: PageName.conversationPage,
        };
      }
    } else if (!privacyPolicy?.enabled && privacyScreen && sandBox) {
      result = {
        showTerms: false,
        targetPage: PageName.conversationPage,
      };
    }

    return result;
  }, [
    s360ConfigService.config?.configDetails?.privacyPolicyDetails,

    s360ConfigService.config?.privacy,
  ]);

  const handleUnreadMessageCounter = useCallback(
    ({ detail: body }) => {
      // Increment unread message counter
      setMessageCounter((prev) => prev + 1);

      // If app is minimized and we have a valid message, mark it as delivered
      if (!isAppOpen && body?.id) {
        const workitemId =
          activeConversation?.workitemId ||
          s360ConfigService.config?.workitemId ||
          s360ConfigService.resumedWorkitemId;

        if (workitemId) {
          // Store the message ID for status update
          messageStatusPendingMap.set(body.id, messageStatuses.DELIVERED);

          // Update message status to DELIVERED via API
          apiService
            .updateMessageStatus(workitemId, body.id, [
              messageStatuses.DELIVERED,
            ])
            .then(() => {
              console.log(
                `Message ${body.id} marked as DELIVERED while app minimized`,
              );
            })
            .catch((error) => {
              console.error(
                `[MessageStatus] Failed to mark ${body.id} as DELIVERED:`,
                error,
              );
              // Keep in pending map for retry when app opens or connection restores
            });
        }
      }
    },
    [isAppOpen, activeConversation],
  );

  useEffect(() => {
    window.addEventListener("MessageNotification", handleUnreadMessageCounter);

    return () => {
      window.removeEventListener(
        "MessageNotification",
        handleUnreadMessageCounter,
      );
    };
  }, [handleUnreadMessageCounter]); // Use handleUnreadMessageCounter as dependency

  // Handle message status updates when app becomes active
  useEffect(() => {
    if (isAppOpen && messageStatusPendingMap.size > 0) {
      const workitemId =
        activeConversation?.workitemId ||
        s360ConfigService.config?.workitemId ||
        s360ConfigService.resumedWorkitemId;

      if (workitemId) {
        console.log("[MessageStatus] App opened, processing pending statuses", {
          count: messageStatusPendingMap.size,
          workitemId,
        });

        // Send DELIVERED+READ for all pending messages to ensure
        // no message is stuck in SENT-only state on the latest workitem
        const entriesToProcess = [...messageStatusPendingMap.entries()];
        entriesToProcess.forEach(([messageId, status]) => {
          apiService
            .updateMessageStatus(workitemId, messageId, [
              messageStatuses.DELIVERED,
              messageStatuses.READ,
            ])
            .then(() => {
              console.log(
                `[MessageStatus] ${messageId} marked as DELIVERED+READ on app open`,
              );
              messageStatusPendingMap.set(messageId, messageStatuses.READ);
            })
            .catch((error) => {
              console.error(
                `[MessageStatus] Failed to update ${messageId} on app open:`,
                error,
              );
              // Will be cleared on next workitem change anyway
            });
        });
      } else {
        // No valid workitem — clear stale entries
        console.log("[MessageStatus] No active workitem, clearing pending map");
        messageStatusPendingMap.clear();
      }
    }
  }, [isAppOpen, activeConversation]);

  function getEnvironment(tenantLocation) {
    const location = tenantLocation ?? "".slice(8);

    const productionDomains = ["app.nextiva.io", "prod.nextiva.io"];
    const isProductionDomain = productionDomains.some(
      (allowedDomain) =>
        location === allowedDomain || location.endsWith(`.${allowedDomain}`),
    );

    return isProductionDomain ? "production" : location;
  }

  useEffect(() => {
    const statsigClient = initializeStatsig(
      s360ConfigService.config?.widgetconfigId, //LOCAL_TEST_USER
      getEnvironment(s360ConfigService.config?.location), //LOCATION
      s360ConfigService.config?.tenantId, // TENANT
    );

    globalFeatureFlagPollingService.initiatePolling(statsigClient);
  }, [s360ConfigService.config]);

  // Cleanup: Clear pending message status map when conversation changes or component unmounts
  useEffect(() => {
    return () => {
      // Clear the pending status map when activeConversation changes or component unmounts
      messageStatusPendingMap.clear();
    };
  }, [activeConversation?.workitemId]);

  useEffect(() => {
    setMessageCounter(0);
  }, [isAppOpen]);

  // Inform websocket layer about app minimized/maximized state
  useEffect(() => {
    try {
      // Expose last known value for consumers attaching later
      window.__S360AppOpenState = isAppOpen;
      const evt = new CustomEvent("S360AppOpenChanged", {
        detail: { isAppOpen },
      });
      window.dispatchEvent(evt);
    } catch (_) {}
  }, [isAppOpen]);
  useEffect(() => {
    if (isAppOpen) {
      if (s360ConfigService?.config?.anonymousClosed) {
        s360ConfigService.config.isNewConversation = false;
      }
    }
    if (s360ConfigService.config.autoPopup) {
      setTimeout(() => {
        setIsAppOpen(true);
      }, 0);

      sendOnAppOpen();
      resetMessageCounter();

      const message = { normalWindow: "true" };
      window.parent.postMessage(message, "*");
    }
  }, []);

  const decidePageandBehaviour = () => {
    if (isLoggedIn) {
      setVisiblePage(PageName.landingPage);
    }

    if (
      !s360ConfigService?.config?.preview &&
      getCookieForContactDetails(s360ConfigService.config.widgetconfigId) &&
      !s360ConfigService?.config?.anonymous &&
      isLoggedIn
    ) {
      moveToPage(PageName.landingPage);
      // setIsAppOpen(true);
      const message = { normalWindow: "true" };
      window.parent.postMessage(message, "*");
      return;
    }

    if (s360ConfigService.config.autoFullScreen) {
      localStorage.setItem("openInFullScreen", "true");
      window.parent.postMessage(
        {
          fullScreen: "true",
        },
        "*", //or "www.parentpage.com"
      );
    } else {
      localStorage.removeItem("openInFullScreen");
    }

    setVisiblePage(determineInitialPage());
  };

  // 1) Navigation / fetching logic — does NOT depend on dynamicFormData
  useEffect(() => {
    if (s360ConfigService?.config) {
      if (!moveNextFromChannels) {
        decidePageandBehaviour();
      }
      if (s360ConfigService?.config?.connectToNextiva && !isOffline) {
        if (s360ConfigService.config.isNewConversation === false) {
          startNewConversation();
          moveToPage(PageName.conversationPage);
        }
      }
      if (
        !s360ConfigService?.config?.showChannels &&
        !s360ConfigService?.config?.preview &&
        isAppOpen
      ) {
        initialize();
      } else if (moveNextFromChannels) {
        setShowChannels(false);
        if (
          s360ConfigService?.config?.anonymous &&
          !s360ConfigService?.config?.preview
        ) {
          if (isOffline) {
            setVisiblePage(PageName.offlinePage);
          } else {
            if (!s360ConfigService?.config?.preview) {
              moveToPage(PageName.conversationPage);
              startNewConversation();
            }
          }
        } else {
          if (isOffline && !s360ConfigService?.config?.preview) {
            // Offline path: respect offline form enabled flag
            const offlineEnabled =
              s360ConfigService?.config?.businessHour?.offlineHour?.formEnabled;
            const offlineSurveyId =
              offlineEnabled &&
              s360ConfigService?.config?.businessHour?.offlineHour?.surveyId;
            if (offlineSurveyId && !s360ConfigService.config.sandBox) {
              apiService
                .getSurveyData(offlineSurveyId)
                .then((res) => {
                  setDynamicFormData(res.data?.layout?.elements);
                })
                .catch(() => {});
            } else {
              setDynamicFormData(null);
            }
            setVisiblePage(PageName.offlinePage);
          } else {
            if (
              !s360ConfigService?.config?.preview &&
              !s360ConfigService?.config?.sandBox
            ) {
              apiService
                .getSurveyData(s360ConfigService?.getConfig().preSurveyId)
                .then((res) => {
                  setDynamicFormData(res.data?.layout?.elements);
                })
                .catch(() => {});

              setVisiblePage(PageName.initialForm);
            }
          }
        }
      }
    }
  }, [
    s360ConfigService?.config,
    moveNextFromChannels,
    isAppOpen,
    isOffline,
    sandBox,
  ]);
  useEffect(() => {
    if (!s360ConfigService?.config?.sandBox) return;

    const showForm = s360ConfigService?.config?.showForm;
    const elems = s360ConfigService?.config?.layoutElements?.layout?.elements;

    if (showForm && elems) {
      setDynamicFormData(elems);

      // make sure we're actually on the form page if sandbox drives that
      if (visiblePage !== PageName.initialForm) {
        setVisiblePage(PageName.initialForm);
      }
    }
  }, [
    s360ConfigService?.config?.sandBox,
    s360ConfigService?.config?.showForm,
    s360ConfigService?.config?.layoutElements,
    visiblePage,
    s360ConfigService.config?.businessHour?.offlineHour?.surveyId,
  ]);

  // 2) React to dynamicFormData changes (safe; doesn't set dynamicFormData again)
  useEffect(() => {
    if (dynamicFormData) {
      if (!s360ConfigService?.config?.sandBox) {
        updatePrimaryIdentification(dynamicFormData);
      }
    }
  }, [dynamicFormData]);

  useEffect(() => {
    if (
      isAppOpen &&
      !s360ConfigService.config.isNewConversation &&
      (s360ConfigService?.getConfig().anonymous ||
        s360ConfigService?.getConfig().connectToNextiva)
    ) {
      if (!isOffline) {
        startNewConversation();
      } else {
        setVisiblePage(PageName.offlinePage);
      }
    } else if (isAppOpen && !s360ConfigService.config.isNewConversation) {
      decidePageandBehaviour();
    }
    if (!isAppOpen) {
      s360ConfigService.activeConversation = null;
      // s360ConfigService.resumedWorkitemId = null;
    }
  }, [isAppOpen]);
  const prevIsAppOpen = useRef(isAppOpen);
  useEffect(() => {
    if (
      s360ConfigService?.config?.configDetails?.pendoIntegratedChat &&
      prevIsAppOpen.current === true &&
      isAppOpen === false
    ) {
      setHasMinimizedOnce(true);
    }
    prevIsAppOpen.current = isAppOpen;
  }, [isAppOpen]);
  useEffect(() => {
    if (
      s360ConfigService?.config?.configDetails?.pendoIntegratedChat &&
      !hasMinimizedOnce &&
      !isAppOpen &&
      !pendoAutoOpened
    ) {
      onStartUpClick();
      setPendoAutoOpened(true);
    }
  }, [
    s360ConfigService?.config?.configDetails?.pendoIntegratedChat,
    hasMinimizedOnce,
    isAppOpen,
    pendoAutoOpened,
  ]);
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--primary-color",
      s360ConfigService?.config?.configDetails?.primaryColor,
    );
  }, [s360ConfigService?.config?.configDetails?.primaryColor]);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--widget-height",
      s360ConfigService?.config?.configDetails?.customDesign
        .startupFloatContainerLaunchIcon.height || "45px",
    );
    document.documentElement.style.setProperty(
      "--widget-width",
      s360ConfigService?.config?.configDetails?.customDesign
        .startupFloatContainerLaunchIcon.width || "45px",
    );
  }, [s360ConfigService?.config?.configDetails?.customDesign]);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--primary-font-color",
      s360ConfigService?.config?.configDetails?.primaryFontColor,
    );
  }, [s360ConfigService?.config?.configDetails?.primaryFontColor]);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--font-family",
      s360ConfigService?.config?.configDetails?.fontFamily,
    );
  }, [s360ConfigService?.config?.configDetails?.fontFamily]);
  useEffect(() => {
    setVisiblePage(decideTermsAndConditionRendering.targetPage);
  }, [decideTermsAndConditionRendering]);
  useEffect(() => {
    if (moveNextFromChannels) {
    }
  }, [moveNextFromChannels]);

  const initialize = () => {
    setShowForm(s360ConfigService?.config?.configDetails?.showForm);

    // If offline: go straight to offline page and fetch offline survey (if any). Do NOT start a new conversation.
    if (isOffline) {
      const offlineSurveyId =
        s360ConfigService?.config?.businessHour?.offlineHour?.surveyId;
      setVisiblePage(PageName.offlinePage);
      if (offlineSurveyId && !s360ConfigService.config.sandBox) {
        apiService
          .getSurveyData(offlineSurveyId)
          .then((res) => {
            setDynamicFormData(res.data?.layout?.elements);
          })
          .catch(() => {});
      }
      return;
    }

    if (
      typeof s360ConfigService?.config?.anonymous == "boolean" &&
      s360ConfigService?.config?.anonymous
    ) {
      startNewConversation();
      moveToPage(PageName.conversationPage);
    }
    setShowActivityIndicator(isLoggedIn ? false : !(!isLoggedIn && showForm));

    if (!isLoggedIn) {
      startTimer();
    }
    if (localStorage.getItem("autoOpenChat")) {
      onStartUpClick();
    }
    if (s360ConfigService.config.disableLocalSession) {
      window.parent.postMessage(
        {
          deleteClientHostId: "true",
        },
        "*", //or "www.parentpage.com"
      );
    }
  };

  useEffect(() => {
    if (props?.chatMaximized) setIsAppOpen(true);
    else setIsAppOpen(false);
  }, [props?.chatMaximized]);

  const handleClose = () => {
    if (sandBox) return;
    setIsVisible(false);
  };

  const isActiveConversation = () => {
    let isClosed = activeConversation && activeConversation?.active === false;
    return !isClosed;
  };

  const startTimer = () => {
    if (s360ConfigService?.config?.popupMessage?.length > 0) {
      s360ConfigService?.config?.popupMessage.sort(
        (a, b) => getTimeInSec(a.time) - getTimeInSec(b.time),
      );
      intervalId = setInterval(countIncrease, 1000);
      if (s360ConfigService.config?.disableTimerMessages === false) {
        let lap = s360ConfigService?.config?.popupMessage?.at(-1)?.time;
        if (lap !== undefined) {
          if (getTimeInSec(lap) < timer) {
            clearInterval(intervalId);
          }
        }
      }
    }
  };

  const getTimeInSec = (time) => {
    if (time !== undefined) {
      const [hours, minutes, seconds] = time.toString().split(":");
      return +hours * 60 * 60 + +minutes * 60 + +seconds;
    }
  };

  const countIncrease = () => {
    let interval = timer + 1;
    setTimer(interval);
    if (s360ConfigService.config.disableTimerMessages === false) {
      let lap = s360ConfigService.config.popupMessage.at(-1).time;
      if (lap !== undefined) {
        if (isActiveConversation() || getTimeInSec(lap) < timer) {
          clearInterval(intervalId);
          setIsVisible(false);
        }
      }
    }

    let msg = s360ConfigService.config.popupMessage.find(
      ({ time }) => getTimeInSec(time) === interval,
    );

    //for popup effect only
    let check = s360ConfigService.config.popupMessage.find(
      ({ time }) => getTimeInSec(time) === interval + 1,
    );

    if (check) {
      setIsVisible(false);
    }

    //To display message
    if (msg) {
      let text = msg.text;
      setText(text);
      setIsVisible(true);
    }
  };

  /**
   * Helper function to cleanup old workitem connections before starting a new one.
   * This prevents multiple keepalive calls running simultaneously for different workitems.
   */
  const cleanupOldWorkitemConnection = (newWorkitemId) => {
    try {
      // Get the current workitem ID from localStorage
      const oldWorkitemId = localStorage.getItem(
        `${s360ConfigService?.config?.widgetconfigId}_workitemId`,
      );

      // Only cleanup if there's an old workitem and it's different from the new one
      if (oldWorkitemId && oldWorkitemId !== newWorkitemId) {
        console.log(`Cleaning up old workitem connection: ${oldWorkitemId}`);

        // Dispatch stopKeepAlive event for the old workitem
        window.dispatchEvent(
          new CustomEvent(`stopKeepAlive_${oldWorkitemId}`, {
            detail: { reason: "SWITCHING_CONVERSATION" },
          }),
        );

        // Disconnect the old workitem's WebSocket connection
        disconnectWorkitem(oldWorkitemId);
      }
    } catch (error) {
      console.error("Error during workitem cleanup:", error);
      // Continue execution even if cleanup fails to avoid breaking the flow
    }
  };

  const startNewConversation = (data) => {
    if (isOffline && !s360ConfigService?.config?.preview) {
      setVisiblePage(PageName.offlinePage);
      return;
    }
    // console.log(
    //   s360ConfigService.config.isNewConversation,
    //   "isNewConversation"
    // );
    if (
      s360ConfigService.config.isNewConversation ||
      s360ConfigService.config.sandBox
    ) {
      return;
    }
    if (data?.closed) {
      setIsAppOpen(false);
      sendOnAppClose();
    }

    const campaignId = s360ConfigService.config.campaignId;
    const tenant = s360ConfigService.config.tenantId;

    s360ConfigService.config.isNewConversation = true;
    s360ConfigService.config.newConversationStarted = true;

    apiService
      .initiateChat(
        tenant,
        campaignId,
        s360ConfigService.thrioConfig.formDetails,
        dynamicFormData,
      )
      .then((chatInitRes) => {
        s360ConfigService.thrioConfig.chatInitRes = chatInitRes.data;
        s360ConfigService.config.workitemId = chatInitRes.data.workitemId;
        localStorage.setItem(
          `${s360ConfigService?.config?.widgetconfigId}_workitemId`,
          chatInitRes.data.workitemId,
        );
        s360ConfigService.resumedWorkitemId = chatInitRes.data.workitemId;

        // s360ConfigService.activeSessions[chatInitRes.data.workitemId] = {
        //   chatMessages: [],
        // };

        chatInitRes.data.isActive = true;
        setActiveConversation(chatInitRes.data);

        // if (isFormSubmitting) {
        //   moveToPage(PageName.conversationPage);
        // }

        // Cleanup any existing workitem connection before starting new one
        cleanupOldWorkitemConnection(chatInitRes.data.workitemId);

        initChatWSConnection(chatInitRes.data.workitemId, true);

        setchatInitRes(chatInitRes.data);
        // updating state just to rerender child components
        if (s360ConfigService?.config?.anonymous) {
          let cookieForContactDetails = getCookieForContactDetails(
            s360ConfigService.config.widgetconfigId,
          );

          if (!cookieForContactDetails) {
            moveToPage(PageName.conversationPage);
          }
        }
        const responseFromValue = chatInitRes?.data?.from;
        const widgetConfigId = s360ConfigService?.config?.widgetconfigId;
        if (responseFromValue && widgetConfigId) {
          const uuidPattern =
            /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
          if (uuidPattern.test(responseFromValue)) {
            setCookieForPrimaryIdentification(
              responseFromValue,
              widgetConfigId,
            );
          }
          setIsLoggedIn(true);
        }
      });
  };

  useEffect(() => {
    if (s360ConfigService.config.preview) {
      initChatWSConnection(s360ConfigService.getConfig().workitemId, true);
    }
  }, [s360ConfigService.config]);

  const downloadCompleteCallabck = () => {
    setDownloadHistoryForWorkItemId(false);
    window.removeEventListener(
      "transcriptDownloadDone",
      downloadCompleteCallabck,
      true,
    );
  };

  const downloadHistory = (ticketId, workItemId) => {
    setDownloadHistoryForWorkItemId({
      ticketId,
      workItemId,
    });

    window.addEventListener("transcriptDownloadDone", downloadCompleteCallabck);
  };

  const actions = {
    setIsAppOpen: (isOpen) => {
      setIsAppOpen(isOpen);
    },
    refreshForFullScreen: () => setRefreshForFullScreen(true),
    startChat: (formDetails) => login(formDetails),
    offlineFormSubmission: (formDetails, captchaToken) =>
      offlineFormSubmission(formDetails, captchaToken),
    offlineFormNoSendEmail: (formDetails, captchaToken) =>
      offlineFormNoSendEmail(formDetails, captchaToken),
    startConversation: (details, isActive, fromHistory) =>
      startConversation(details, isActive, fromHistory),
    showLandingScreen: () => moveToPage(PageName.landingPage),
    onStartUpClick: () => onStartUpClick(),
    markActiveConversationAsClosed: () => markActiveConversationAsClosed(),
    onHideChatWindow: () => closeAndPostMessage(),
    showPopUpMessage: (message) => triggerPopupMessage(message),
    submitForm: (contactFormDetails) => submitForm(contactFormDetails),
    closePopup: () => closePopup(),
    setActiveConversation: (conversation) => {
      setActiveConversation(conversation);
    },
    setAgentInfo: (data) => setAgentInfo(data),
    moveToPage: (pageName) => moveToPage(pageName),
    startNewConversation: () => startNewConversation(),
    downloadHistory,
    startInitChatWSConnection: (workitemId) =>
      initChatWSConnection(workitemId, true),
    safeReconnectWebSocket: (workitemId, resume = true) =>
      safeReconnectWebSocket(workitemId, resume),
  };

  const moveToConversationPage = () => {
    forceAutoLogin();
  };

  const forceAutoLogin = () => {
    let configFormDetails = { ...s360ConfigService.s360UserConfig };
    login(configFormDetails);
  };

  const onStartUpClick = () => {
    setIsAppOpen((prevIsAppOpen) => {
      const newIsAppOpen = !prevIsAppOpen;

      if (newIsAppOpen) {
        if (localStorage.getItem("openInFullScreen")) {
          window.parent.postMessage(
            {
              fullScreen: "true",
            },
            "*",
          );
        }
        if (
          localStorage.getItem("openInFullScreen") === undefined ||
          localStorage.getItem("openInFullScreen") === null
        ) {
          sendOnAppOpen();
        }
      } else {
        sendOnAppClose();
      }
      localStorage.removeItem("finalvalue");
      return newIsAppOpen;
    });

    resetMessageCounter();
  };

  const [chatInitRes, setchatInitRes] = useState(null);
  const [isFormSubmitting, setIsFormSubmitting] = useState(false);
  const login = async (formDetails) => {
    if (s360ConfigService.config.sandBox) return;
    if (s360ConfigService.thrioConfig) {
      if (!formDetails) {
        moveToPage(PageName.initialForm);
        return;
      }
      setIsFormSubmitting(true);

      apiService
        .submitFormData(formDetails, dynamicFormData)
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            // setCookieForContactDetails(
            //   res.data,
            //   s360ConfigService.config.widgetconfigId
            // );

            HWUser.updateUserDetails(res.data);
            s360ConfigService.thrioConfig.contactDetails = {
              ...s360ConfigService.thrioConfig.contactDetails,
              ...res.data,
            };
          } else {
            // setCookieForContactDetails(
            //   res.data,
            //   s360ConfigService.config.widgetconfigId
            // );
            s360ConfigService.thrioConfig.contactDetails = res.data;
          }
          setIsFormSubmitting(false);

          moveToPage(PageName.landingPage);
        })
        .catch((err) => {
          setIsFormSubmitting(false);
          if (err.response.status === 404) {
            moveToPage(PageName.landingPage);
          }
        });

      s360ConfigService.thrioConfig.formDetails = formDetails;
    }
  };

  const offlineFormNoSendEmail = async (formDetails, captchaToken) => {
    const campaignId = s360ConfigService.config.campaignId;
    const tenant = s360ConfigService.config.tenantId;

    s360ConfigService.config.isNewConversation = true;
    s360ConfigService.config.newConversationStarted = true;

    return apiService
      .initiateChat(tenant, campaignId, formDetails, dynamicFormData, true)
      .then((res) => {
        if (res?.data?.workitemId) {
          return apiService.chatReadyOfflineForm(res?.data?.workitemId);
        }
      })
      .catch((err) => {
        console.warn(err);
      });
  };

  const offlineFormSubmission = async (formDetails, captchaToken) => {
    if (s360ConfigService.thrioConfig) {
      if (!formDetails) {
        moveToPage(PageName.initialForm);
        return;
      }
      setIsFormSubmitting(true);
      return apiService.sendOfflineEmail(
        formDetails,
        captchaToken,
        dynamicFormData,
      );
    }
  };

  const markActiveConversationAsClosed = () => {
    if (activeConversation) {
      let activeConversationTemp = { ...activeConversation };
      activeConversationTemp.active = false;
      activeConversationTemp.isActive = false;
      setActiveConversation(activeConversationTemp);
    }
  };

  const triggerPopupMessage = (message) => {
    if (!message) {
      return;
    }
    setPopUpMessage(message);
    setShowActivityIndicator(false);
  };

  // Moves to existing conversation.
  const startConversation = (
    conversationDetials,
    isActive,
    fromHistory = false,
  ) => {
    conversationDetials.isActive = isActive;
    s360ConfigService.thrioConfig.chatInitRes = {
      workitemId: conversationDetials.workitemId,
    };
    s360ConfigService.config.workitemId = conversationDetials.workitemId;

    if (fromHistory) {
      conversationDetials.fromHistory = fromHistory;
    }
    if (isActive) {
      // Cleanup any existing workitem connection before switching to this conversation
      // IMPORTANT: Must call cleanup BEFORE updating localStorage so it can read the old workitemId
      cleanupOldWorkitemConnection(conversationDetials.workitemId);

      initChatWSConnection(conversationDetials.workitemId, true);
    }

    // Update localStorage to reflect the current workitem
    // IMPORTANT: Must happen AFTER cleanup so cleanup can read the old workitemId
    localStorage.setItem(
      `${s360ConfigService?.config?.widgetconfigId}_workitemId`,
      conversationDetials.workitemId,
    );

    setActiveConversation(conversationDetials);
    setIsActive(isActive);
    clearInterval(intervalId);

    moveToPage(PageName.conversationPage);
  };

  const moveToPage = (pageName) => {
    setVisiblePage(pageName);
  };

  const onAPIError = (error) => {
    let messageToShow =
      error && error.message === "Network Error"
        ? "Please check your internet connectivity."
        : "Could not connect to server, please try again.";
    triggerPopupMessage(messageToShow);
  };

  const containerStyle = useCallback(() => {
    const x = window.matchMedia("(max-width: 400px)");
    const isOpenInFullScreen = localStorage.getItem("openInFullScreen");
    const isPreview = s360ConfigService?.config?.preview;
    const customMainContainerStyles =
      s360ConfigService.config?.customDesign?.mainFloatContainer;

    return {
      flexDirection: "column",
      borderRadius:
        x.matches || isOpenInFullScreen || isPreview ? "0px" : "10px",
      ...(customMainContainerStyles || {}),
    };
  }, [
    isAppOpen,
    s360ConfigService?.config?.preview,
    s360ConfigService?.config?.customDesign?.mainFloatContainer,
  ]);

  const submitForm = (contactFormDetails) => {
    return apiService
      .createTicketWithFormData(contactFormDetails)
      .then((result) => {
        HWLog.info("Contact form result: ", result.data);
        if (!result.data || result.data.error) {
          setErrorMessage(result.data.error || "");
          triggerPopupMessage(
            result.data.error || "Something went worng. Please try again.",
          );
        } else {
          triggerPopupMessage("Form submitted successfully");
        }
      })
      .catch(onAPIError);
  };

  const closePopup = () => {
    setPopUpMessage(null);
  };

  const parseSurveyTriggerResponse = (msg) => {
    setShowFeedbackIframe(true);
    setIframeSRC(msg?.message?.text);
    setSessionIdForClose(msg?.sessionId);
  };

  const handleCloseIcon = () => {
    setShowFeedbackIframe(false);
    setIsIframeClose(true);
  };

  const resetIframe = () => setIsIframeClose(false);

  const increaseMessageCounter = () => setMessageCounter(messageCounter + 1);

  const resetMessageCounter = () => setMessageCounter(0);

  const state = {
    visiblePage,
    isAppOpen,
    popUpMessage,
    showActivityIndicator,
    isVisible,
    timer,
    text,
    isActive,
    refreshForFullScreen,
    showFeedbackIframe,
    iframeSRC,
    isIframeClose,
    uniboxSingleRefresh,
    messageCounter,
    sessionIdForClose,
    activeConversation,
    clientChannel,
    autoLoggedIn,
    errorMessage,
    isFormSubmitting,
  };
  useEffect(() => {
    setIsLoggedIn(getCookieForContactDetails(widgetId));
  }, [visiblePage, isLoggedIn]);

  return (
    <>
      {s360ConfigService?.config?.configDetails?.pendoIntegratedChat
        ? !isAppOpen && (
            <StartUp
              refresh={props.refresh}
              actions={actions}
              notificationChild={
                messageCounter > 0 && !isAppOpen ? (
                  <MessageNotification
                    counter={messageCounter > 9 ? "9+" : messageCounter}
                  />
                ) : null
              }
            />
          )
        : !s360ConfigService.config.hideIcon && (
            <StartUp
              refresh={props.refresh}
              actions={actions}
              notificationChild={
                messageCounter > 0 && !isAppOpen ? (
                  <MessageNotification
                    counter={messageCounter > 9 ? "9+" : messageCounter}
                  />
                ) : null
              }
            />
          )}

      <div
        key={s360ConfigService.config.autoPopup}
        id="container"
        className={
          s360ConfigService?.config?.preview
            ? "s360-main-float-container-preview"
            : `s360-main-float-container${isFullScreen ? "-fs" : ""}`
        }
        style={{
          ...containerStyle(),
          display: isAppOpen ? "flex" : "none",
        }}
      >
        {visiblePage !== PageName.conversationPage &&
          visiblePage !== PageName.landingPage && (
            <InitialFormHeader
              {...props}
              actions={actions}
              onStartUpClick={onStartUpClick}
            />
          )}
        {visiblePage === PageName.initialForm &&
          s360ConfigService?.config?.showChannels &&
          !isLoggedIn &&
          !moveNextFromChannels && (
            <InitialChannelFormDetails
              {...props}
              moveToNextScreen={() => setMoveNextFromChannels(true)}
            />
          )}
        {visiblePage === PageName.offlinePage &&
          (s360ConfigService?.config?.businessHour?.offlineHour?.formEnabled &&
          dynamicFormData ? (
            <DynamicForm
              key={dynamicFormKey}
              decideTermsAndConditionRendering={
                decideTermsAndConditionRendering
              }
              offline={
                s360ConfigService?.config?.isCurrentWorkingHour === false
              }
              data={dynamicFormData}
              offlineForm={
                s360ConfigService.config.businessHour?.offlineHour?.formEnabled
              }
              moveToConversationPage={moveToConversationPage}
              actions={actions}
            />
          ) : (
            <OfflineMessage />
          ))}

        {visiblePage === PageName.initialForm &&
          dynamicFormData &&
          !isLoggedIn &&
          (!s360ConfigService?.config?.showChannels ||
            moveNextFromChannels) && (
            <DynamicForm
              key={dynamicFormKey}
              decideTermsAndConditionRendering={
                decideTermsAndConditionRendering
              }
              offline={
                s360ConfigService?.config?.isCurrentWorkingHour === false
              }
              data={dynamicFormData}
              moveToConversationPage={moveToConversationPage}
              actions={actions}
            />
          )}

        {visiblePage === PageName.landingPage && (
          <LandingPage
            isAppOpen={isAppOpen}
            chatInitRes={chatInitRes}
            agentInfo={agentInfo}
            uniboxSingleRefreshChange={() => setUniboxSingleRefresh(true)}
            key={"landing-page-" + isLoggedIn}
            config={s360ConfigService.config}
            actions={actions}
            {...state}
            clientChannel={clientChannel}
            {...props}
          />
        )}

        {visiblePage === PageName.privacyPage &&
          s360ConfigService?.config?.configDetails?.privacyPolicyDetails
            ?.enabled &&
          s360ConfigService?.config?.configDetails?.privacyPolicyDetails
            ?.type === "full" && (
            <NCXPrivacyPolicyBig
              config={
                s360ConfigService.config.configDetails.privacyPolicyDetails
              }
              onAccept={() => {
                localStorage.setItem(
                  `nextiva-widget-terms-acceptance-${s360ConfigService?.config?.widgetconfigId}`,
                  "true",
                );
                s360ConfigService?.setTermsAceeptedForThisSession(true);
                setTermsAccepted(true);
                setVisiblePage(PageName.conversationPage);
              }}
            />
          )}

        {visiblePage === PageName.conversationPage &&
          visiblePage !== PageName.privacyPage && (
            <LoaderProviderWrapper>
              <ConversationPage
                backupMessages={backupMessages}
                setBackupMessages={setBackupMessages}
                removeAllCookies={props.removeAllCookies}
                termsAccepted={termsAccepted}
                sandBoxedAttachment={sandBoxedAttachment}
                sandBoxedAgentInfo={sandBoxedAgentInfo}
                sandBoxedReadreciept={sandBoxedReadreciept}
                isAppOpen={isAppOpen}
                setIsAppOpen={setIsAppOpen}
                closeAndPostMessage={closeAndPostMessage}
                agentInfo={agentInfo}
                increaseMessageCounter={increaseMessageCounter}
                uniboxSingleRefresh={uniboxSingleRefresh}
                resetIframe={resetIframe}
                chatStatus={isAppOpen}
                key={"conversation-page-" + isLoggedIn}
                config={s360ConfigService.config}
                conversation={activeConversation}
                actions={actions}
                {...state}
                {...props}
                parseSurveyTriggerResponse={parseSurveyTriggerResponse}
                isIframeClose={isIframeClose}
                sessionIdForClose={sessionIdForClose}
                refresh={props.refresh}
              />
            </LoaderProviderWrapper>
          )}
        {downloadHistoryForWorkItemId &&
          visiblePage !== PageName.privacyPage && (
            <div
              style={{
                width: "100%",
                height: "fit-content",
                position: "absolute",
                top: -9999,
                left: 0,
              }}
            >
              <ConversationPage
                backupMessages={backupMessages}
                setBackupMessages={setBackupMessages}
                removeAllCookies={props.removeAllCookies}
                sandBoxedAttachment={sandBoxedAttachment}
                sandBoxedAgentInfo={sandBoxedAgentInfo}
                sandBoxedReadreciept={sandBoxedReadreciept}
                setIsAppOpen={setIsAppOpen}
                agentInfo={agentInfo}
                increaseMessageCounter={increaseMessageCounter}
                uniboxSingleRefresh={uniboxSingleRefresh}
                resetIframe={resetIframe}
                chatStatus={isAppOpen}
                isAppOpen={isAppOpen}
                key={"conversation-page-" + isLoggedIn}
                config={s360ConfigService.config}
                conversation={activeConversation}
                actions={actions}
                {...state}
                {...props}
                parseSurveyTriggerResponse={parseSurveyTriggerResponse}
                isIframeClose={isIframeClose}
                sessionIdForClose={sessionIdForClose}
                downloadHistoryForWorkItemId={downloadHistoryForWorkItemId}
              />
            </div>
          )}
        {popUpMessage && (
          <PopUpMessage
            popUpMessage={popUpMessage}
            onClose={closePopup}
            addTodoItem={props.addTodoItem}
          />
        )}
      </div>

      {showFeedbackIframe && (
        <IframeContainer src={iframeSRC} handleCloseIcon={handleCloseIcon} />
      )}
      {!isLoggedIn &&
        isVisible &&
        !isAppOpen &&
        s360ConfigService.config.enableTimerMessages && (
          <div
            id="s360-popup-float-message-container-id"
            className="s360-popup-float-message-container s360-hidden"
          >
            <div className="s360-popup-float-img">
              <img
                src={closeImg}
                height="8px"
                alt="closeImg"
                width="8px"
                style={{
                  marginBottom: "4px",
                  marginLeft: "128px",
                  cursor: "pointer",
                }}
                id="s360-popup-float-img-id"
                onClick={handleClose}
              />
            </div>
            <span
              id="s360-popup-float-message-id"
              className="s360-popup-float-message"
            >
              {text}
            </span>
          </div>
        )}
    </>
  );
}

export default Simplify360Chat;
